import { styled } from "@linaria/react";
import { isWideScreen } from "../../../@css-style";

export const ElContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: var(--content-width);
  margin: 0 auto;
  padding: 0;
  ${String(isWideScreen)} {
    padding: 0 1em !important;
    /* background-color: red !important; */
  }
`;
